import REQ from '../../utils/REQ';
import { PageBase } from '@components/page/base';

/**
 * @package
 */
export const PageError = () => {
  return <PageBase req={REQ.ERROR} />;
};
